import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { UrlShortenerService } from '../services/url-shortener.service';
import { Subject } from 'rxjs';
import { ShortenedUrlInfo } from '../interfaces';
import { HelperService } from '../services/helper.service';
import { contentUnavailableTree } from '../utils/content-unavailable.utils';

export const canActivateShortener: CanActivateFn = (route, state) => {
  const shortenerService = inject(UrlShortenerService);
  const helperService = inject(HelperService);
  const router = inject(Router);
  const slug = route.params['slug'];

  if (!slug) {
    return false;
  }

  const subject = new Subject<boolean | UrlTree>();

  shortenerService.getShortenedUrlByBackhalf(slug).subscribe({
    next: (shortenedInfo: ShortenedUrlInfo) => {
      if (shortenedInfo) {
        const relativeUrl = shortenedInfo.redirectionUrl.replace(helperService.getCurrentOrigin() + '/', '');
        const urlTree = router.parseUrl(relativeUrl);
        subject.next(urlTree);
      } else {
        subject.next(contentUnavailableTree(router));
      }
      subject.complete();
    },
    error: (err) => {
      subject.next(contentUnavailableTree(router));
      subject.complete();
    },
  });

  return subject.asObservable();
};
